module["exports"] = [
  "?#? #?#"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_CA/address/postcode.js
// module id = 999
// module chunks = 0